export default "__VITE_ASSET__BbkMRUYF__"